import { createContext } from "react";
import { Settings } from "@/interfaces";

export interface SettingsContextProps {
  settings?: Settings;
  setSettings: (settings?: Settings) => void;
  loadSettings: () => Promise<any>;
}

export const SettingsContext = createContext<SettingsContextProps>({
  settings: undefined,
  setSettings: () => undefined,
  loadSettings: () => Promise.resolve(),
});
